<div>
    <div class="row mt-2">
        <div class="row mt-2 mb-2">
            <div class="col-8">
                <div class="mb-3 d-flex align-items-center">
                    <jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
                    <div class="ms-2">
                        <button class="btn btn-sm btn-outline-info" (click)="onClearSort($event)" jhiTranslate="global.clear-sort"></button>
                    </div>
                    <span *ngIf="isLoading" class="throbber ms-2"></span>
                </div>
            </div>
            <div class="col-4">
                <jhi-columns-dropdown (columnsSelectedEvent)="onColumnsSelected($event)" [staticColumns]="staticColumns" [showEnvironmentsLabel]="false"
                                      class="ms-2 float-end">
                </jhi-columns-dropdown>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-striped table-bordered table-curved">
                <thead>
                <tr jhiSort [(predicate)]="predicate" [(ascending)]="isAscending" [callback]="this.sort.bind(this)">
                    <th *jhiHasAnyAuthority="VIEW_NAMES_PERMISSIONS" [hidden]="hiddenColumns['TEST_ENTRY']">
                            <span [jhiSortBy]="varResultsSort.TEST_ENTRY">
                                <span jhiTranslate="head-to-head-query.column.header.test.entry"></span><span
                                    class="fa fa-sort"></span>
                            </span>
                    </th>
                    <th *jhiHasAnyAuthority="VIEW_NAMES_PERMISSIONS" [hidden]="hiddenColumns['STD_ENTRY']">
                            <span [jhiSortBy]="varResultsSort.STD_ENTRY">
                                <span jhiTranslate="head-to-head-query.column.header.standard.entry"></span><span
                                    class="fa fa-sort"></span>
                            </span>
                    </th>
                    <th [hidden]="hiddenColumns['NO_ENV']">
                            <span [jhiSortBy]="varResultsSort.NO_ENV">
                                <span jhiTranslate="head-to-head-query.column.header.no.env"></span><span
                                    class="fa fa-sort"></span>
                            </span>
                    </th>
                    <th [hidden]="hiddenColumns['NO_SUP']">
                            <span [jhiSortBy]="varResultsSort.NO_SUP">
                                <span jhiTranslate="head-to-head-query.column.header.no.sup"></span><span
                                    class="fa fa-sort"></span>
                            </span>
                    </th>
                    <th [hidden]="hiddenColumns['MEAN_TEST']">
                            <span [jhiSortBy]="varResultsSort.MEAN_TEST">
                                <span jhiTranslate="head-to-head-query.column.header.mean.test"></span><span
                                    class="fa fa-sort"></span>
                            </span>
                    </th>
                    <th [hidden]="hiddenColumns['MEAN_STD']">
                            <span [jhiSortBy]="varResultsSort.MEAN_STD">
                                <span jhiTranslate="head-to-head-query.column.header.mean.std"></span><span
                                    class="fa fa-sort"></span>
                            </span>
                    </th>
                    <th [hidden]="hiddenColumns['PVAL']">
                            <span [jhiSortBy]="varResultsSort.PVAL">
                                <span jhiTranslate="head-to-head-query.column.header.pval"></span><span
                                    class="fa fa-sort"></span>
                            </span>
                    </th>
                    <th [hidden]="hiddenColumns['MEAN_DIFF']">
                            <span [jhiSortBy]="varResultsSort.MEAN_DIFF">
                                <span jhiTranslate="head-to-head-query.column.header.mean.diff"></span><span
                                    class="fa fa-sort"></span>
                            </span>
                    </th>
                </tr>
                </thead>
                <tbody *ngIf="results.length else nodata">
                    <tr *ngFor="let result of pagedData; trackBy: trackId; index as index">
                        <td *jhiHasAnyAuthority="VIEW_NAMES_PERMISSIONS" [hidden]="hiddenColumns['TEST_ENTRY']">
                            <a class="link" (click)="germplasmDetailsPopupService.open(result.testGID)">
                                <truncate-span [textInput]="result.testDesignation" [maxLength]="MAX_NAME_DISPLAY_SIZE">
                                </truncate-span>
                            </a>
                        </td>
                        <td *jhiHasAnyAuthority="VIEW_NAMES_PERMISSIONS" [hidden]="hiddenColumns['STD_ENTRY']">
                            <a class="link" (click)="germplasmDetailsPopupService.open(result.standardGID)">
                                <truncate-span [textInput]="result.standardDesignation" [maxLength]="MAX_NAME_DISPLAY_SIZE">
                                </truncate-span>
                            </a>
                        </td>
                        <td [hidden]="hiddenColumns['NO_ENV']">{{result.headToHeadResultMap[variable.variableId].noOfEnv}}</td>
                        <td [hidden]="hiddenColumns['NO_SUP']">{{result.headToHeadResultMap[variable.variableId].noSUP}}</td>
                        <td [hidden]="hiddenColumns['MEAN_TEST']">{{result.headToHeadResultMap[variable.variableId].meanTest}}</td>
                        <td [hidden]="hiddenColumns['MEAN_STD']">{{result.headToHeadResultMap[variable.variableId].meanSTD}}</td>
                        <td [hidden]="hiddenColumns['PVAL']">{{result.headToHeadResultMap[variable.variableId].pval}}</td>
                        <td [hidden]="hiddenColumns['MEAN_DIFF']">{{result.headToHeadResultMap[variable.variableId].meanDiff}}</td>
                    </tr>
                </tbody>
            </table>
            <ng-template #nodata>
                <tbody>
                <tr>
                    <td [attr.colspan]="9" jhiTranslate="no.data"></td>
                </tr>
                </tbody>
            </ng-template>
        </div>
        <div *ngIf="results && results.length">
            <div class="row">
                <div class="col">
                    <div class="pagination-container">
                        <div class="pagination-box pagination-box-left">
                            <div>
                                <jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
                            </div>
                        </div>
                        <div class="pagination-box">
                            <ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
                                            [maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
                        </div>
                        <div class="pagination-box pagination-box-right">
                            <div class="d-flex align-items-center">
                                <label for="itemsPerPage" class="control-label control-label-left" jhiTranslate="global.items.per.page"></label>
                                <select [(ngModel)]="itemsPerPage" class="form-select ms-2" id="itemsPerPage" [disabled]="isLoading" (change)="resetTable();" style="width:95px">
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="75">75</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
